module.exports = __webpack_public_path__ + "static/media/digital-tachograph.b4b841c3.svg";